import Vue from 'vue'
import VueRouter from 'vue-router'
import homeRouter from './home'
import store from '../store/index'

Vue.use(VueRouter)

const routers = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: () => {
        if(store.state.user){
          return '/home'
        } else  {
          return '/login'
        }
      }
    },
    {
      path: '/login', // 登录
      component: () => import('../login/login'),
      meta: {
        title: '2020北京公益慈善汇展',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/forget', // 忘记密码
      component: () => import('../login/forget'),
      meta: {
        title: '2020北京公益慈善汇展',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/home',
      component: () => import('../views/Home'),
      children: homeRouter,
    },
    {
      path: '/commonts',
      component: () => import('../views/commonts'),
      meta: {
        title: '预览',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/Template1',
      component: () => import('../views/Template1'),
      meta: {
        title: '网店',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/Template2',
      component: () => import('../views/Template2'),
      meta: {
        title: '网店',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/Template3',
      component: () => import('../views/Template3'),
      meta: {
        title: '网店',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/Template4',
      component: () => import('../views/Template4'),
      meta: {
        title: '网店',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/Template5',
      component: () => import('../views/Template5'),
      meta: {
        title: '网店',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/Template6',
      component: () => import('../views/Template6'),
      meta: {
        title: '网店',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/fhzx',
      component: () => import('../views/fhzx'),
      meta: {
        title: '北京市社会组织孵化中心',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/fwzx',
      component: () => import('../views/fwzx'),
      meta: {
        title: '北京市社会组织发展服务中心',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/dbjd',
      component: () => import('../views/dbjd'),
      meta: {
        title: '社会组织孵化基地东部基地',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/bbjd',
      component: () => import('../views/bbjd'),
      meta: {
        title: '社会组织孵化基地北部基地',
        needLogin: false // 是否需要登录才能访问
      }
    },
  ],
  // 指定该钩子函数，返回坐标值即可
  scrollBehavior (to, from, savedPosition) {
    console.log(to, from, savedPosition)
    return { x: 0, y: 0 }
  }
})


export default routers
